import { StateSchema } from '@/shared/types/store';
import { LocalStorageService } from '@/shared/services/localStorage.service';

export const getIsAuth = (state: StateSchema) => {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) return false;
  return state.auth.isAuth || !!LocalStorageService.getAccessTokenFromAnyStorage();
};
